import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  emailValidator,
  MobileNoIntValidator,
  requiredValidator,
} from "./../../components/formFields/CommonValidator";
import { useAppDispatch, useAppSelector } from "./../../app/hooks";
import {
  createHotelQuotation,
  getHotelQuotationByID,
  updateHotelQuotation,
} from "./services/quotation.services";
import {
  clearHotelQuotationInformation,
  setQuotationType,
} from "./quotationSlice";
import ShadowCard from "./../../components/common/ShadowCard";
import moment from "moment";
import { getHotelInquiryByID } from "./../inquiry/services/inquiry.services";
import {
  getContactByID,
  insertContactFromOtherPlace,
} from "./../contact/services/contact.services";
import FormSelectionField from "./../../components/formFields/FormSelectionField";
import { getAllActiveCompanies } from "./../company/services/company.services";
import { clearInquiryDetails } from "./../inquiry/inquirySlice";
import { LoadingPanel } from "./../../components/layout/Loading";
import { getLeadByID } from "./../lead/services/lead.services";
import { clearLeadDetails } from "./../lead/leadSlice";
import { clearContactDetails } from "./../contact/contactSlice";
import { getAdminSettings } from "./../adminsetting/services/adminsetting.services";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import FormTextField from "../../components/formFields/FormTextField";
import FormDatePicker from "../../components/formFields/FormDateField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import RippleButton from "../../components/common/RippleButton";
import { getAllActiveNationalities } from "../nationality/services/nationality.services";
import { INationality } from "../nationality/nationalityModel";
// import { getAllActiveRoomCategories } from "../roomcategory/services/roomCategory.services";
// import { IRoomCategory } from "../roomcategory/roomCategoryModel";
import FormRatingField from "../../components/formFields/FormRatingField";
import FormTextArea from "../../components/formFields/FormTextArea";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { BOOKINGSTATUSHOTEL, NAMEPREFIX } from "../../_contstants/common";
import { ILeadSource } from "../leadsource/leadsourceModel";
import {
  getAllActiveHotelRoomCategory,
  getAllHotels,
  getHotelByID,
  getHotelSpecialRate,
  // getHotelSpecialRate,
} from "../hotel/services/hotel.services";
import { getAllActiveCities } from "../city/services/city.services";
import { ICity } from "../city/cityModel";
import { getAllActiveGST } from "../gst/services/gst.services";
import { IGST } from "../gst/gstModel";
import FormSingleSuggestionField from "../../components/formFields/FormSingleSuggestionField";
import { ICompany } from "../company/companyModel";
import { getAllActiveLeadSource } from "../leadsource/services/leadsource.service";
import { IMealType } from "../mealtype/mealtypeModel";
import { getAllActiveMealTypes } from "../mealtype/services/mealtype.services";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { openDialog } from "../../components/dialog/dialogSlice";
import AppDialog from "../../components/dialog/Dialog";
import TravellerHotelRoomArray from "./quotationforms/TravellerHotelRoomArray";
import FormTimePicker from "../../components/formFields/FormTimeField";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const TotalChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const GSTList = useAppSelector((state) => state.gst.GSTList);
  const RoomRatePerNight = formRenderProps.valueGetter("RoomRatePerNight") || 0;
  const ExtraAdultRatePerNight =
    formRenderProps.valueGetter("ExtraAdultRatePerNight") || 0;
  const TotalRoomCost = formRenderProps.valueGetter("TotalRoomCost") || 0;
  const GSTAmount = formRenderProps.valueGetter("GSTAmount") || 0;
  // const TaxesAndFees = formRenderProps.valueGetter("TaxesAndFees") || 0;
  const ServiceCharges = formRenderProps.valueGetter("ServiceCharges") || 0;
  const NoOfNights = formRenderProps.valueGetter("NoOfNights") || 0;
  const ExtraAdult = formRenderProps.valueGetter("ExtraAdult") || 0;
  const TotalRoom = formRenderProps.valueGetter("TotalRoom") || 0;
  // const MarkupPercentage = formRenderProps.valueGetter("MarkupPercentage") || 0;
  const GSTID = formRenderProps.valueGetter("GSTID");

  useEffect(() => {
    formRenderProps.onChange("TotalRoomCost", {
      value: +(
        +(+RoomRatePerNight * +NoOfNights * +TotalRoom) +
        +(+ExtraAdultRatePerNight * +ExtraAdult * +NoOfNights)
      )?.toFixed(),
    });
  }, [
    NoOfNights,
    ExtraAdult,
    RoomRatePerNight,
    ExtraAdultRatePerNight,
    TotalRoom,
  ]);

  useEffect(() => {
    formRenderProps.onChange("TotalAmount", {
      value: +(
        +(+RoomRatePerNight * +NoOfNights * +TotalRoom) +
        +(+ExtraAdultRatePerNight * +ExtraAdult * +NoOfNights) +
        // +TaxesAndFees +
        +ServiceCharges +
        +GSTAmount
      )?.toFixed(),
    });
  }, [
    NoOfNights,
    ExtraAdult,
    RoomRatePerNight,
    ExtraAdultRatePerNight,
    // TaxesAndFees,
    ServiceCharges,
    GSTAmount,
    TotalRoom,
    // MarkupPercentage,
  ]);

  useEffect(() => {
    const GSTDATA = GSTList?.find((gst: any) => gst?.ID === GSTID);
    formRenderProps.onChange("GSTAmount", {
      value: +(
        ((+ServiceCharges + +TotalRoomCost) *
          (GSTDATA && GSTDATA?.GSTPer ? GSTDATA?.GSTPer : 0)) /
        100
      )?.toFixed(),
    });
  }, [GSTID, ServiceCharges, TotalRoomCost]);

  return null;
};

const TourDatechangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const CheckInDate = formRenderProps.valueGetter("CheckInDate");
  const NoOfNights = formRenderProps.valueGetter("NoOfNights") || 0;
  const Hotel = formRenderProps.valueGetter(`HotelID`);

  useEffect(() => {
    const CheckOutDate = CheckInDate
      ? moment(CheckInDate)
          .add(+NoOfNights || 0, "days")
          .toDate()
      : "";
    formRenderProps.onChange(`CheckOutDate`, {
      value: CheckOutDate,
    });
  }, [CheckInDate, NoOfNights]);

  const fetchHotelRoomCategory = async () => {
    const res = await dispatch(
      getAllActiveHotelRoomCategory({ HotelID: +Hotel })
    );
    if (res.meta?.requestStatus === "fulfilled") {
      formRenderProps.onChange(`roomtype_options`, {
        value: res.payload || [],
      });
    }
  };

  useEffect(() => {
    if (Hotel && !isNaN(+Hotel)) {
      fetchHotelRoomCategory();
    } else {
      formRenderProps.onChange(`RoomTypeID`, {
        value: null,
      });
      formRenderProps.onChange(`roomtype_options`, {
        value: [],
      });
    }
  }, [Hotel]);

  return null;
};

const CreateHotelQuotation: React.FC = () => {
  const gridRef = useRef<any>(null);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const HotelQuotationID = location.state?.HotelQuotationID;
  const InquiryID = location.state?.InquiryID;

  const loading = useAppSelector((state) => state.quotation.loading);
  const contactLoading = useAppSelector((state) => state.contact.formLoading);
  const HotelQuotationDetail = useAppSelector(
    (state) => state.quotation.HotelQuotationDetail
  );
  const InquiryHotelDetails = useAppSelector(
    (state) => state.inquiry.InquiryHotelDetails
  );
  const LeadSourceList = useAppSelector(
    (state) => state.leadsource.LeadSourceList
  );
  const CityList = useAppSelector((state) => state.city.CityList);
  const GSTList = useAppSelector((state) => state.gst.GSTList);

  const LeadDetails = useAppSelector((state) => state.lead.LeadDetails);
  const leadLoading = useAppSelector((state) => state.lead.formLoading);
  const ContactDetails = useAppSelector(
    (state) => state.contact.ContactDetails
  );
  const AdminSettingDetails = useAppSelector(
    (state) => state.adminsetting.AdminSettingDetails
  );

  const NationalityList = useAppSelector(
    (state) => state.nationality.NationalityList
  );

  const CompanyList = useAppSelector((state) => state.company.CompanyList);

  const MealTypeList = useAppSelector((state) => state.mealType.MealTypeList);

  const LeadID = location.state?.LeadID;
  const ContactID = location.state?.ContactID;

  const [formKey, setFormKey] = useState(1);
  const [initialValues, setInitialValues] = useState<any>(HotelQuotationDetail);

  useEffect(() => {
    dispatch(getAllActiveCompanies());
    dispatch(getAdminSettings());
    dispatch(getAllActiveGST());
    dispatch(getAllActiveCities());
    dispatch(getAllActiveNationalities());
    dispatch(getAllActiveLeadSource());
    // dispatch(getAllActiveRoomCategories());
    // dispatch(getAllActiveFoodOptions());
    dispatch(getAllActiveMealTypes());

    if (HotelQuotationID) {
      dispatch(getHotelQuotationByID({ ID: +HotelQuotationID }));
    } else if (InquiryID) {
      dispatch(getHotelInquiryByID(InquiryID));
    } else if (LeadID) {
      dispatch(getLeadByID(LeadID));
    } else if (ContactID) {
      dispatch(getContactByID(ContactID));
    }

    return () => {
      dispatch(clearHotelQuotationInformation());
      dispatch(clearInquiryDetails());
    };
  }, []);

  useEffect(() => {
    if (InquiryHotelDetails?.ID) {
      const rooms = InquiryHotelDetails?.HotelRooms || [];

      const totalAdult = rooms.reduce(
        (sum: any, room: any) => sum + (room.Adults || 0),
        0
      );
      const totalChild = rooms.reduce(
        (sum: any, room: any) => sum + (room.Child || 0),
        0
      );
      const totalRoom = rooms.length;

      const totalExtraAdult = rooms.reduce((sum: any, room: any) => {
        const extra = (room.Adults || 0) - 2;
        return sum + (extra > 0 ? extra : 0);
      }, 0);
      setInitialValues({
        ...initialValues,
        Initial: InquiryHotelDetails?.Initial,
        FirstName: InquiryHotelDetails?.FirstName,
        LastName: InquiryHotelDetails?.LastName,
        MobileNo: InquiryHotelDetails?.MobileNo,
        EmailID: InquiryHotelDetails?.EmailID,
        ContactID: InquiryHotelDetails?.ContactID,
        LeadSourceID: InquiryHotelDetails?.InquirySourceID,
        NationalityID: InquiryHotelDetails?.NationalityID,
        Rating: InquiryHotelDetails?.StarRating,
        CheckInDate: InquiryHotelDetails?.CheckIn,
        CheckOutDate: InquiryHotelDetails?.CheckOut,
        NoOfNights: InquiryHotelDetails?.NoOfNights,
        TotalAdult: totalAdult - totalExtraAdult,
        TotalRoom: totalRoom,
        TotalChild: totalChild,
        ExtraAdult: totalExtraAdult,
        MealTypeID: InquiryHotelDetails?.MealTypeID,
        HotelRooms: InquiryHotelDetails?.HotelRooms || [],
        Travelers: InquiryHotelDetails?.Travelers,
        CityID: InquiryHotelDetails?.CityID,
      });
    }
    return () => {
      dispatch(clearInquiryDetails());
    };
  }, [InquiryHotelDetails]);

  useEffect(() => {
    if (LeadDetails?.ID) {
      setInitialValues({
        ...initialValues,
        Initial: LeadDetails?.Initial,
        FirstName: LeadDetails?.FirstName,
        LastName: LeadDetails?.LastName,
        MobileNo: LeadDetails?.MobileNo,
        EmailID: LeadDetails?.EmailID,
        LeadSourceID: LeadDetails?.LeadSourceID,
        ContactID: LeadDetails?.ContactID,
        LeadID: LeadDetails?.ID,
      });
    }
    return () => {
      dispatch(clearLeadDetails());
    };
  }, [LeadDetails]);

  useEffect(() => {
    if (ContactDetails?.ID) {
      setInitialValues({
        ...initialValues,
        Initial: ContactDetails?.Initial,
        FirstName: ContactDetails?.FirstName,
        LastName: ContactDetails?.LastName,
        MobileNo: ContactDetails?.MobileNo,
        EmailID: ContactDetails?.EmailID,
        LeadSourceID: ContactDetails?.LeadSourceID,
        ContactID: ContactDetails?.ID,
      });
    }
    return () => {
      dispatch(clearContactDetails());
    };
  }, [ContactDetails]);

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      ...HotelQuotationDetail,
    });
  }, [HotelQuotationDetail]);

  useEffect(() => {
    if (!HotelQuotationID) {
      setInitialValues({
        ...initialValues,
        GstPer: AdminSettingDetails.GST,
        TermsAndCondition: AdminSettingDetails.HotelTermsAndCondition,
      });
    }
  }, [AdminSettingDetails]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [initialValues]);

  const handleHotelSearchChange = React.useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllHotels({ HotelName: search }));
      if (result.payload) {
        formRenderProps.onChange(field, {
          value: result.payload,
        });
      }
    },
    [dispatch]
  );

  const fetchHotelRate = async (formRenderProps: FormRenderProps) => {
    const HotelID = formRenderProps.valueGetter("HotelID");
    const CheckInDate = formRenderProps.valueGetter("CheckInDate");
    const RoomTypeID = formRenderProps.valueGetter("RoomTypeID");
    const MealTypeID = formRenderProps.valueGetter("MealTypeID");

    const IsAutoRate = !isNaN(Number(HotelID));

    if (IsAutoRate && HotelID && CheckInDate && RoomTypeID && MealTypeID) {
      try {
        const res = await dispatch(
          getHotelSpecialRate({
            HotelID: HotelID,
            CheckInDate: moment(CheckInDate).format("YYYY-MM-DD"),
            MealTypeID: MealTypeID,
            RoomCategoryID: RoomTypeID,
          })
        );
        if (res.meta?.requestStatus === "fulfilled") {
          formRenderProps.onChange(`RoomRatePerNight`, {
            value: res?.payload?.Rate || 0,
          });
        }
      } catch (error) {
        console.error("Failed to fetch hotel rate:", error);
        formRenderProps.onChange(`RoomRatePerNight`, {
          value: 0,
        });
      }
    }
  };

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleAccommodationChange = (formRenderProps: FormRenderProps) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      fetchHotelRate(formRenderProps);
    }, 500);
  };

  const handleSubmit = async (values: any) => {
    let contactID = values?.ContactID ? +values?.ContactID : null;
    const insertContactPayload = {
      Initial: values?.Initial ? values?.Initial : "",
      FirstName: values?.FirstName ? values?.FirstName : "",
      LastName: values?.LastName ? values?.LastName : "",
      MobileNo: values?.MobileNo ? values?.MobileNo : "",
      CountryCode: values?.CountryCode ? values?.CountryCode : "",
      EmailID: values?.EmailID ? values?.EmailID : "",
      LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
    };

    if (!HotelQuotationID && !InquiryID && !LeadID && !ContactID) {
      const response = await dispatch(
        insertContactFromOtherPlace(insertContactPayload)
      );

      if (
        response.meta.requestStatus === "fulfilled" &&
        response.payload?.Data?.ID
      ) {
        contactID = +response.payload.Data.ID || null;
      } else {
        return;
      }
    }

    try {
      if (HotelQuotationID) {
        const editPayload = {
          ID: HotelQuotationID ? +HotelQuotationID : null,
          Initial: values?.Initial ? values?.Initial : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          TotalRoom: values?.TotalRoom ? +values?.TotalRoom : null,
          LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
          MealTypeID: values?.MealTypeID ? +values?.MealTypeID : null,
          TotalAdult: values?.TotalAdult ? +values?.TotalAdult : null,
          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          CheckInDate: values?.CheckInDate
            ? moment(values?.CheckInDate)?.format("YYYY-MM-DD")
            : "",
          CheckOutDate: values?.CheckOutDate
            ? moment(values?.CheckOutDate)?.format("YYYY-MM-DD")
            : "",
          CheckInTime: values?.CheckInTime
            ? moment(values?.CheckInTime)?.format("HH:mm:ss")
            : "",
          CheckOutTime: values?.CheckOutTime
            ? moment(values?.CheckOutTime)?.format("HH:mm:ss")
            : "",
          ExpiryDate: values?.ExpiryDate
            ? moment(values?.ExpiryDate)?.format("YYYY-MM-DD")
            : "",
          NationalityID: values?.NationalityID ? +values?.NationalityID : null,
          HotelID: values?.HotelID ? `${values?.HotelID}` : "",
          CityID: values?.CityID ? +values?.CityID : null,
          Rating: values?.Rating ? `${values?.Rating}` : "",
          BookingStatus: values?.BookingStatus ? values?.BookingStatus : "",
          RoomTypeID: values?.RoomTypeID ? +values?.RoomTypeID : null,
          HotelAddress: values?.HotelAddress ? values?.HotelAddress : "",
          HotelRooms: values?.HotelRooms ? values?.HotelRooms : [],
          Travelers: values?.Travelers ? values?.Travelers : 0,
          NoOfNights: values?.NoOfNights ? +values?.NoOfNights : null,
          TotalChild: values?.TotalChild ? +values?.TotalChild : null,
          ExtraAdult: values?.ExtraAdult ? +values?.ExtraAdult : null,
          Remarks: values?.Remarks ? values?.Remarks : "",
          TermsAndCondition: values?.TermsAndCondition
            ? values?.TermsAndCondition
            : "",
          RoomRatePerNight: values?.RoomRatePerNight
            ? +values?.RoomRatePerNight
            : null,
          ExtraAdultRatePerNight: values?.ExtraAdultRatePerNight
            ? +values?.ExtraAdultRatePerNight
            : null,
          TotalRoomCost: values?.TotalRoomCost ? +values?.TotalRoomCost : null,
          TaxesAndFees: values?.TaxesAndFees ? +values?.TaxesAndFees : null,
          ServiceCharges: values?.ServiceCharges
            ? +values?.ServiceCharges
            : null,
          MarkupPercentage: null,
          // MarkupPercentage: values?.MarkupPercentage
          //   ? +values?.MarkupPercentage
          //   : null,
          GSTID: values?.GSTID ? +values?.GSTID : null,
          GSTAmount: values?.GSTAmount ? +values?.GSTAmount : null,
          TotalAmount: values?.TotalAmount ? +values?.TotalAmount : null,
        };
        const response = await dispatch(updateHotelQuotation(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/quotation");
          dispatch(setQuotationType("hotel"));
        }
      } else {
        const insertPayload = {
          ContactID: contactID,
          LeadID: values?.LeadID ? +values?.LeadID : null,
          InquiryID: values?.InquiryID ? +values?.InquiryID : null,
          Initial: values?.Initial ? values?.Initial : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          TotalRoom: values?.TotalRoom ? +values?.TotalRoom : null,
          EmailID: values?.EmailID ? values?.EmailID : "",
          LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
          MealTypeID: values?.MealTypeID ? +values?.MealTypeID : null,
          TotalAdult: values?.TotalAdult ? +values?.TotalAdult : null,
          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          CheckInDate: values?.CheckInDate
            ? moment(values?.CheckInDate)?.format("YYYY-MM-DD")
            : "",
          CheckOutDate: values?.CheckOutDate
            ? moment(values?.CheckOutDate)?.format("YYYY-MM-DD")
            : "",
          CheckInTime: values?.CheckInTime
            ? moment(values?.CheckInTime)?.format("HH:mm:ss")
            : "",
          CheckOutTime: values?.CheckOutTime
            ? moment(values?.CheckOutTime)?.format("HH:mm:ss")
            : "",
          ExpiryDate: values?.ExpiryDate
            ? moment(values?.ExpiryDate)?.format("YYYY-MM-DD")
            : "",
          NationalityID: values?.NationalityID ? +values?.NationalityID : null,
          HotelID: values?.HotelID ? `${values?.HotelID}` : "",
          CityID: values?.CityID ? +values?.CityID : null,
          Rating: values?.Rating ? `${values?.Rating}` : "",
          BookingStatus: values?.BookingStatus ? values?.BookingStatus : "",
          RoomTypeID: values?.RoomTypeID ? +values?.RoomTypeID : null,
          HotelAddress: values?.HotelAddress ? values?.HotelAddress : "",
          HotelRooms: values?.HotelRooms ? values?.HotelRooms : [],
          Travelers: values?.Travelers ? values?.Travelers : 0,
          NoOfNights: values?.NoOfNights ? +values?.NoOfNights : null,
          TotalChild: values?.TotalChild ? +values?.TotalChild : null,
          ExtraAdult: values?.ExtraAdult ? +values?.ExtraAdult : null,
          Remarks: values?.Remarks ? values?.Remarks : "",
          TermsAndCondition: values?.TermsAndCondition
            ? values?.TermsAndCondition
            : "",
          RoomRatePerNight: values?.RoomRatePerNight
            ? +values?.RoomRatePerNight
            : null,
          ExtraAdultRatePerNight: values?.ExtraAdultRatePerNight
            ? +values?.ExtraAdultRatePerNight
            : null,
          TotalRoomCost: values?.TotalRoomCost ? +values?.TotalRoomCost : null,
          TaxesAndFees: values?.TaxesAndFees ? +values?.TaxesAndFees : null,
          ServiceCharges: values?.ServiceCharges
            ? +values?.ServiceCharges
            : null,
          MarkupPercentage: null,
          // MarkupPercentage: values?.MarkupPercentage
          //   ? +values?.MarkupPercentage
          //   : null,
          GSTID: values?.GSTID ? +values?.GSTID : null,
          GSTAmount: values?.GSTAmount ? +values?.GSTAmount : null,
          TotalAmount: values?.TotalAmount ? +values?.TotalAmount : null,
        };
        const response = await dispatch(createHotelQuotation(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/quotation");
          dispatch(setQuotationType("hotel"));
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {(loading || contactLoading || leadLoading) && (
        <LoadingPanel gridRef={gridRef} />
      )}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={initialValues}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4 className="typography-head">
                    {"Hotel Quotation Details"}
                  </Typography.h4>
                </GridLayoutItem>
              </GridLayout>
              <ShadowCard
                style={{
                  width: "100%",
                  boxShadow: "none",
                  backgroundColor: "#f8f9fa",
                  marginBottom: 16,
                }}
              >
                <GridLayout
                  style={{ marginRight: 10 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[{ width: "50%" }, { width: "50%" }]}
                >
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="m-0"
                      id={"CompanyID"}
                      name={"CompanyID"}
                      label={"Company"}
                      placeholder="Company"
                      astrike={true}
                      component={FormSelectionField}
                      validator={requiredValidator}
                      options={CompanyList?.map((company: ICompany) => {
                        return {
                          value: company?.ID,
                          label: company?.CompanyName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="m-0"
                      validator={requiredValidator}
                      astrike={true}
                      name={`ExpiryDate`}
                      label="Expiry Date"
                      format="dd/MM/yyyy"
                      minDate={moment().toDate()}
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
              <div className="w-100 d-flex gap-3 align-items-streach">
                <ShadowCard
                  style={{
                    width: "50%",
                    boxShadow: "none",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <Typography.h5 className="m-0">
                    Client Information
                  </Typography.h5>
                  <GridLayout
                    style={{ marginRight: 10 }}
                    gap={{ rows: 0, cols: 10 }}
                    cols={[{ width: "50%" }, { width: "50%" }]}
                  >
                    <GridLayoutItem className="d-flex gap-2" colSpan={2}>
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 2,
                        }}
                        id={"Initial"}
                        name={"Initial"}
                        label={"Initial"}
                        placeholder="i.e. Mr."
                        component={FormSelectionField}
                        options={NAMEPREFIX?.map((initial: any) => {
                          return {
                            value: initial?.value,
                            label: initial?.label,
                          };
                        })}
                      />
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 3,
                        }}
                        name="FirstName"
                        label="First Name"
                        placeholder="i.e.John"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 3,
                        }}
                        name="LastName"
                        label="Last Name"
                        placeholder="i.e. Smith"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="EmailID"
                        label="Email ID"
                        astrike={true}
                        placeholder="i.e. example@gmail.com"
                        component={FormTextField}
                        validator={emailValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="mb-1">
                      <Field
                        name="MobileNo"
                        label="Mobile No."
                        type="text"
                        maxLength={16}
                        onKeyPress={(e: any) => {
                          const allowedChars = /^[0-9+]$/;
                          if (!allowedChars.test(e?.key)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="i.e. 9999999999"
                        component={FormTextField}
                        astrike={true}
                        validator={MobileNoIntValidator}
                      />
                    </GridLayoutItem>
                    {!HotelQuotationID &&
                      !InquiryID &&
                      !LeadID &&
                      !ContactID && (
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="w-100"
                            id={"LeadSourceID"}
                            name={"LeadSourceID"}
                            label={"Lead Source"}
                            placeholder="Lead Source"
                            component={FormSelectionField}
                            astrike={true}
                            validator={requiredValidator}
                            options={LeadSourceList?.map(
                              (leadsource: ILeadSource) => {
                                return {
                                  value: leadsource?.ID,
                                  label: leadsource?.Source,
                                };
                              }
                            )}
                          />
                        </GridLayoutItem>
                      )}
                    <GridLayoutItem>
                      <Field
                        name={`NationalityID`}
                        label="Nationality"
                        placeholder="i.e. Indian"
                        component={FormSelectionField}
                        options={NationalityList?.map(
                          (nationality: INationality) => {
                            return {
                              value: nationality?.ID,
                              label: nationality?.Nationality,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </ShadowCard>
                <ShadowCard
                  style={{
                    width: "50%",
                    boxShadow: "none",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <Typography.h5 className="m-0">Hotel Details</Typography.h5>
                  <GridLayout
                    style={{ marginRight: 10 }}
                    gap={{ rows: 0, cols: 10 }}
                    cols={[{ width: "50%" }, { width: "50%" }]}
                  >
                    <GridLayoutItem colSpan={2}>
                      <Field
                        name={`CityID`}
                        label="Location/City"
                        placeholder="i.e. Ahmedabad"
                        component={FormSelectionField}
                        options={CityList?.map((city: ICity) => {
                          return {
                            value: city?.ID,
                            label: city?.CityName,
                          };
                        })}
                        // onChange={() => {
                        //   formRenderProps.onChange("HotelID", {
                        //     value: "",
                        //   });
                        // }}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={2}>
                      <Field
                        name={`HotelID`}
                        label="Hotel"
                        placeholder="Hotel"
                        component={FormSingleSuggestionField}
                        validator={requiredValidator}
                        astrike={true}
                        onChange={async (e) => {
                          if (e?.value && !isNaN(+e?.value)) {
                            const res: any = await dispatch(
                              getHotelByID(e?.value)
                            );
                            if (res.meta.requestStatus === "fulfilled") {
                              formRenderProps.onChange("HotelAddress", {
                                value: res?.payload?.Address,
                              });
                              formRenderProps.onChange("Rating", {
                                value: res?.payload?.HotelCategory,
                              });
                            }
                          }
                          handleAccommodationChange(formRenderProps);
                        }}
                        fetchIncrementalData={(search: any) =>
                          handleHotelSearchChange(
                            search,
                            "hotel_options",
                            formRenderProps
                          )
                        }
                        updateOptions={(newOption: any) => {
                          const currentOptions =
                            formRenderProps.valueGetter("hotel_options") || [];
                          const updatedOptions = newOption?.value
                            ? [
                                {
                                  ID: newOption.label,
                                  HotelName: newOption.label,
                                },
                                ...currentOptions,
                              ]
                            : currentOptions;
                          formRenderProps.onChange(`hotel_options`, {
                            value: updatedOptions,
                          });
                        }}
                        options={
                          formRenderProps
                            .valueGetter("hotel_options")
                            ?.map((item: any) => {
                              return {
                                value: item?.ID,
                                label: item?.HotelName,
                              };
                            }) || []
                        }
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        name={`RoomTypeID`}
                        label="Room Type"
                        placeholder="Room Type"
                        component={FormSelectionField}
                        options={
                          formRenderProps
                            .valueGetter("roomtype_options")
                            ?.map((item: any) => {
                              return {
                                value: item?.ID,
                                label: item?.RoomCategoryName,
                              };
                            }) || []
                        }
                        onChange={() => {
                          handleAccommodationChange(formRenderProps);
                        }}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="Rating"
                        component={FormRatingField}
                        label="Star Rating"
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={2}>
                      <Field
                        name={`HotelAddress`}
                        label="Hotel Address"
                        component={FormTextArea}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </ShadowCard>
              </div>
              <ShadowCard
                style={{
                  width: "100%",
                  boxShadow: "none",
                  backgroundColor: "#f8f9fa",
                  marginTop: 16,
                }}
              >
                <Typography.h5 className="m-0">Booking Details</Typography.h5>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem className="d-flex gap-2" colSpan={3}>
                    <Field
                      wrapperClassName="w-100"
                      validator={requiredValidator}
                      astrike={true}
                      name={`CheckInDate`}
                      label="Check-in Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      minDate={moment().toDate()}
                      onChange={() => {
                        handleAccommodationChange(formRenderProps);
                      }}
                    />
                    <Field
                      wrapperClassName="w-100"
                      name={"CheckInTime"}
                      label={"Check-in Time"}
                      component={FormTimePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                    {/* </GridLayoutItem>
                  <GridLayoutItem> */}
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="NoOfNights"
                      label="No Of Nights"
                      placeholder="0"
                      max={50}
                      format="n0"
                      component={FormNumericTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                    {/* </GridLayoutItem>
                  <GridLayoutItem> */}
                    <Field
                      wrapperClassName="w-100"
                      validator={requiredValidator}
                      astrike={true}
                      name={`CheckOutDate`}
                      label="Check-out Date"
                      format="dd/MM/yyyy"
                      minDate={
                        formRenderProps.valueGetter("CheckInDate")
                          ? moment(
                              formRenderProps.valueGetter("CheckInDate")
                            ).toDate()
                          : moment().toDate()
                      }
                      component={FormDatePicker}
                      disabled={true}
                    />
                    <Field
                      wrapperClassName="w-100"
                      name={"CheckOutTime"}
                      label={"Check-out Time"}
                      component={FormTimePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        marginTop: 15,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Label>
                        {"Travellers"}
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Button
                        type="button"
                        style={{ background: "#fff" }}
                        onClick={() =>
                          dispatch(openDialog("quotetravellerEditDialog"))
                        }
                      >
                        {formRenderProps.valueGetter("Travelers") || 0}
                      </Button>
                    </GridLayoutItem>
                    <TravellerEditDialog formRenderProps={formRenderProps} />
                  </GridLayoutItem>
                  <GridLayoutItem className="d-flex gap-2">
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="TotalAdult"
                      label="Total Adult"
                      placeholder="0"
                      max={50}
                      format="n0"
                      disabled={true}
                      component={FormNumericTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="ExtraAdult"
                      label="Extra Adult"
                      placeholder="0"
                      max={50}
                      format="n0"
                      disabled={true}
                      component={FormNumericTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem className="d-flex gap-2">
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="TotalChild"
                      label="Total Child"
                      placeholder="0"
                      max={50}
                      format="n0"
                      disabled={true}
                      component={FormNumericTextField}
                    />
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="TotalRoom"
                      label="Total Rooms"
                      placeholder="0"
                      max={50}
                      format="n0"
                      disabled={true}
                      component={FormNumericTextField}
                      // validator={requiredValidator}
                      // astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`MealTypeID`}
                      label="Meal Type"
                      placeholder="Meal Type"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={MealTypeList?.map((mealtype: IMealType) => {
                        return {
                          value: mealtype?.ID,
                          label: mealtype?.MealType,
                        };
                      })}
                      onChange={() => {
                        handleAccommodationChange(formRenderProps);
                      }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`BookingStatus`}
                      label="Booking Status"
                      placeholder="Booking Status"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={BOOKINGSTATUSHOTEL?.map((status: any) => {
                        return {
                          value: status?.value,
                          label: status?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
              <ShadowCard
                style={{
                  width: "100%",
                  boxShadow: "none",
                  backgroundColor: "#f8f9fa",
                  marginTop: 16,
                }}
              >
                <Typography.h5 className="m-0">
                  Special Requests & Notes
                </Typography.h5>
                <GridLayout
                  gap={{ rows: 0, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem>
                    <Field
                      name="Remarks"
                      label="Special Requests"
                      placeholder="Fare Rules"
                      component={FormRichTextField}
                      wrapperStyle={{
                        width: "100%",
                      }}
                      style={{
                        height: 150,
                      }}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
              <ShadowCard
                style={{
                  width: "100%",
                  boxShadow: "none",
                  backgroundColor: "#f8f9fa",
                  marginTop: 16,
                }}
              >
                <Typography.h5 className="m-0">Terms & Condition</Typography.h5>
                <GridLayout
                  gap={{ rows: 0, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem>
                    <Field
                      name="TermsAndCondition"
                      label="Terms & Condition"
                      placeholder="Terms & Condition"
                      component={FormRichTextField}
                      wrapperStyle={{
                        width: "100%",
                      }}
                      style={{
                        height: 150,
                      }}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
              <ShadowCard
                style={{
                  width: "100%",
                  boxShadow: "none",
                  backgroundColor: "#f8f9fa",
                  marginTop: 16,
                }}
              >
                <Typography.h5 className="m-0">Booking Details</Typography.h5>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="RoomRatePerNight"
                      label="Room Rate (Per Night)"
                      placeholder="0"
                      component={FormNumericTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="ExtraAdultRatePerNight"
                      label="Extra Adult Rate (Per Night)"
                      placeholder="0"
                      component={FormNumericTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="TotalRoomCost"
                      label="Total Room Cost"
                      placeholder="0"
                      component={FormNumericTextField}
                      disabled={true}
                    />
                  </GridLayoutItem>
                  {/* <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="TaxesAndFees"
                      label="Taxes & Fees"
                      placeholder="0"
                      component={FormNumericTextField}
                    />
                  </GridLayoutItem> */}
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="ServiceCharges"
                      label="Service Charges / Markup"
                      placeholder="0"
                      component={FormNumericTextField}
                    />
                  </GridLayoutItem>
                  {/* <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="MarkupPercentage"
                      label="Markup"
                      placeholder="0"
                      component={FormNumericTextField}
                    />
                  </GridLayoutItem> */}
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="GSTID"
                      label="GST"
                      placeholder="0"
                      component={FormSelectionField}
                      options={GSTList?.map((gst: IGST) => {
                        return {
                          value: gst?.ID,
                          label: gst?.Title,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field w-100"
                      name="TotalAmount"
                      label="Total Amount"
                      placeholder="0"
                      component={FormNumericTextField}
                      disabled={true}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>

              <GridLayoutItem
                colSpan={3}
                style={{
                  textAlign: "end",
                  marginTop: 16,
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={HotelQuotationID ? "Update" : "Save"}
                  type="submit"
                  disabled={
                    !formRenderProps.allowSubmit || loading || contactLoading
                  }
                  loading={loading || contactLoading}
                />
                <RippleButton
                  fillMode="outline"
                  themeColor="primary"
                  style={{ marginLeft: 10 }}
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </RippleButton>
              </GridLayoutItem>
            </ShadowCard>
            <TotalChangeWatcher formRenderProps={formRenderProps} />
            <TourDatechangeWatcher formRenderProps={formRenderProps} />
            {/* <AccomodationHotelChangeWatcher formRenderProps={formRenderProps} /> */}
          </FormElement>
        )}
      />
    </>
  );
};

interface TravellerEditDialogProps {
  formRenderProps: FormRenderProps;
}

const TravellerEditDialog: React.FC<TravellerEditDialogProps> = ({
  formRenderProps,
}) => {
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  return (
    <>
      {dialogName === "quotetravellerEditDialog" && (
        <AppDialog>
          <GridLayout style={{ maxWidth: 600 }}>
            <FieldArray
              formRenderProps={formRenderProps}
              component={TravellerHotelRoomArray}
              name="HotelRooms"
            />
          </GridLayout>
        </AppDialog>
      )}
    </>
  );
};

export default CreateHotelQuotation;
